import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  RadioSelector,
  ErrorMsg,
} from "@onegovbugs/onegov-react-components";
import { hasAnyValue, isSelected, validate } from "../../../utils/Validation";
import styles from "./Associate.module.scss";
import { storeAssociateDetail, saveApplication } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import AssociateList from "../../../components/floraFauna/associate/AssociateList";

const AssociateDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();
  const [showErrors, setShowErrors] = useState(false);

  const dispatch = useDispatch();

  const associateDetail = useSelector((state) => state.associateDetail);
  const [associateList, setAssociateList] = useState(
    associateDetail && associateDetail.associateList
      ? associateDetail.associateList.map((on) => ({ ...on }))
      : []
  );
  const [hasAssociates, setAssociates] = useState(
    associateDetail && associateDetail.hasAssociates
      ? associateDetail.hasAssociates
      : null
  );

  const radioOptionsAssociates = [
    {
      value: "yes",
      label: "Yes",
    },
    {
      value: "no",
      label: "No",
    },
  ];

  // validation
  const [errors, setErrors] = useState({
    hasAssociates: false,
    associateList: false,
    associateListLimit: false,
  });

  const validators = [
    {
      fieldName: "hasAssociates",
      fieldValue: hasAssociates,
      isValid: (v) => isSelected(v),
    },
    {
      fieldName: "associateList",
      fieldValue: associateList,
      isValid: (v) => hasAssociates == "no" || hasAnyValue(v),
    },
  ];

  const validatorsOnAdd = [
    {
      fieldName: "associateListLimit",
      fieldValue: associateList,
      isValid: (v) => hasAssociates == "no" || !(v.length > 4),
    },
  ];

  useEffect(() => {
    validate(validators, setErrors);
  }, [hasAssociates, associateList]);

  useEffect(() => {
    validate(validatorsOnAdd, setErrors);
  }, [hasAssociates, associateList]);

  const deleteActionHandler = (i) => {
    let values = [...associateList];
    values.splice(i, 1);
    setAssociateList([...values]);

    const associationRecord = {
      associateList: values
    };
    dispatch(storeAssociateDetail(associationRecord));
  };

  const storeData = (finished) => {
    const associationRecord = {
      hasAssociates: hasAssociates,
      associateList: hasAssociates === "no" ? [] : associateList,
      finished,
      step : 3
    };
    dispatch(storeAssociateDetail(associationRecord));
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          You may enter the details of up to 5 associates online. Should your
          project involve more than 5 associates, please submit their details as
          an attachment at the end of the application. If attaching details of
          additional associates please include all of the details requested on
          this page.
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <label>Do you have any associates?</label>
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <div className={styles.topMargin24}>
            <RadioSelector
              options={radioOptionsAssociates}
              onSelectionChange={(selectedValue) => {
                setShowErrors(false);
                setAssociates(selectedValue);
              }}
              initialValue={hasAssociates}
            />
            {errors.hasAssociates && showErrors ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Please make a selection."}
              />
            ) : null}
          </div>
        </div>
      </div>
      {hasAssociates == "yes" && (
        <>
          <div className={`row ${styles.topMargin24}`}>
            <div className={"col-12"}>
              <AssociateList
                props={props}
                associateList={associateList}
                deleteActionHandler={deleteActionHandler}
              />
            </div>
          </div>
          <div className={`row ${styles.buttonCont}`}>
            <div className={`col-12`}>
              <Button
                secondary
                onClick={() => {
                  if (validate(validatorsOnAdd, setErrors)) {
                    props.history.push(`./associate/detail`);
                  } else {
                    setShowErrors(true);
                  }
                }}
              >
                Add associate
              </Button>
              {errors.associateListLimit && showErrors ? (
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Only 5 associates can be added."}
                />
              ) : null}

              {!errors.hasAssociates && errors.associateList && showErrors ? (
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please add associate."}
                />
              ) : null}
            </div>
          </div>
        </>
      )}

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                dispatch(
                  saveApplication("step3", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step3", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <AssociateDetail {...props} />);
